import { initContract } from '@ts-rest/core';
import { agentContract } from './agent';
import { kycContract } from './kyc';
import { coacContract } from './coac';
import { reconciliationContract } from './reconciliation';
import { managerAliasContract } from './manager-alias';
import { bookHealthContract } from './book-health';
import { mcpAdminContract } from './mcp-admin';
import { retentionContract } from './retention';
import { firmConfigContract } from './firm-config';
import { systemStatusContract } from './system-status';
import { onboardingContract } from './onboarding';
import { factFindContract } from './fact-find';
import { documentsContract } from './documents';
import { clientReviewContract } from './client-review';
import { clientBookContract } from './client-book';
import { contactsContract } from './contacts';
import { clientsContract } from './clients';
import { suitabilityRecordsContract } from './suitability-records';
import { relationshipsContract } from './relationships';
import { portalContract } from './portal';
import { governanceContract } from './governance';
import { vulnerabilityContract } from './vulnerability';
import { pcfContract } from './pcf';
import { snapshotContract } from './snapshot';
import { kpiContract } from './kpi';
import { cashContract } from './cash';
import { sharePointContract } from './sharepoint';
import { opsContract } from './ops';
import { reportingContract } from './reporting';
import { reviewQueueContract } from './review-queue';
import { complyDashboardContract } from './comply-dashboard';
import { complyRegCalendarContract } from './comply-reg-calendar';
import { complyBreachRegisterContract } from './comply-breach-register';
import { complySuitabilityContract } from './comply-suitability';
import { complyConsumerDutyContract } from './comply-consumer-duty';
import { complyFinCrimeKycContract } from './comply-fin-crime-kyc';
import { complyTcTrackerContract } from './comply-tc-tracker';
import { complyCmpReviewsContract } from './comply-cmp-reviews';
import { complyFairValueContract } from './comply-fair-value';
import { complyCallIntelligenceContract } from './comply-call-intelligence';
import { deskPagesContract } from './desk-pages';
import { documentDraftsContract } from './document-drafts';
import { suitabilityAssessmentContract } from './suitability-assessment';
import { vulnerabilityAssessmentContract } from './vulnerability-assessment';
import { amlAssessmentContract } from './aml-assessment';
import { entityAmlAssessmentContract } from './entity-aml-assessment';
import { mandateLetterContract } from './mandate-letter';
import { deskDashboardContract } from './desk-dashboard';
import { viewPagesContract } from './view-pages';
import { viewClientIntelligenceContract } from './view-client-intelligence';
import { securityReferenceContract } from './security-reference';
import { userPrefsContract } from './user-prefs';
import { workflowsContract } from './workflows';
import { analyticsContract } from './analytics';
import { auditContract } from './audit';

const c = initContract();

export const apiContract = c.router({
    agent: agentContract,
    coac: coacContract,
    onboarding: onboardingContract,
    factFind: factFindContract,
    documents: documentsContract,
    clientReview: clientReviewContract,
    clientBook: clientBookContract,
    contacts: contactsContract,
    clients: clientsContract,
    suitabilityRecords: suitabilityRecordsContract,
    relationships: relationshipsContract,
    portal: portalContract,
    governance: governanceContract,
    vulnerability: vulnerabilityContract,
    pcf: pcfContract,
    reconciliation: reconciliationContract,
    snapshot: snapshotContract,
    kpi: kpiContract,
    cash: cashContract,
    managerAlias: managerAliasContract,
    bookHealth: bookHealthContract,
    mcpAdmin: mcpAdminContract,
    retention: retentionContract,
    firmConfig: firmConfigContract,
    systemStatus: systemStatusContract,
    sharePoint: sharePointContract,
    ops: opsContract,
    reporting: reportingContract,
    reviewQueue: reviewQueueContract,
    complyDashboard: complyDashboardContract,
    complyRegCalendar: complyRegCalendarContract,
    complyBreachRegister: complyBreachRegisterContract,
    complySuitability: complySuitabilityContract,
    complyConsumerDuty: complyConsumerDutyContract,
    complyFinCrimeKyc: complyFinCrimeKycContract,
    complyTcTracker: complyTcTrackerContract,
    complyCmpReviews: complyCmpReviewsContract,
    complyFairValue: complyFairValueContract,
    complyCallIntelligence: complyCallIntelligenceContract,
    deskPages: deskPagesContract,
    documentDrafts: documentDraftsContract,
    suitabilityAssessment: suitabilityAssessmentContract,
    vulnerabilityAssessment: vulnerabilityAssessmentContract,
    amlAssessment: amlAssessmentContract,
    entityAmlAssessment: entityAmlAssessmentContract,
    mandateLetter: mandateLetterContract,
    deskDashboard: deskDashboardContract,
    viewPages: viewPagesContract,
    viewClientIntelligence: viewClientIntelligenceContract,
    securityReference: securityReferenceContract,
    userPrefs: userPrefsContract,
    workflows: workflowsContract,
    analytics: analyticsContract,
    audit: auditContract,
    integrations: c.router({
        kyc: kycContract,
    }),
});

export {
    agentContract,
    kycContract,
    coacContract,
    onboardingContract,
    factFindContract,
    documentsContract,
    clientReviewContract,
    clientBookContract,
    contactsContract,
    clientsContract,
    suitabilityRecordsContract,
    relationshipsContract,
    portalContract,
    governanceContract,
    vulnerabilityContract,
    pcfContract,
    reconciliationContract,
    snapshotContract,
    kpiContract,
    cashContract,
    managerAliasContract,
    bookHealthContract,
    mcpAdminContract,
    firmConfigContract,
    systemStatusContract,
    sharePointContract,
    opsContract,
    reportingContract,
    reviewQueueContract,
    complyDashboardContract,
    complyRegCalendarContract,
    complyBreachRegisterContract,
    complySuitabilityContract,
    complyConsumerDutyContract,
    complyFinCrimeKycContract,
    complyTcTrackerContract,
    complyCmpReviewsContract,
    complyFairValueContract,
    complyCallIntelligenceContract,
    deskPagesContract,
    documentDraftsContract,
    suitabilityAssessmentContract,
    vulnerabilityAssessmentContract,
    amlAssessmentContract,
    entityAmlAssessmentContract,
    mandateLetterContract,
    deskDashboardContract,
    viewPagesContract,
    viewClientIntelligenceContract,
    securityReferenceContract,
    userPrefsContract,
    workflowsContract,
    analyticsContract,
    auditContract,
};
export type {
    AuditPillar,
    AuditDepartment,
    AuditTrailQuery,
    AuditTrailRow,
    AuditTrailResponse,
    AuditEmployee,
    AuditEmployeesResponse,
} from './audit';
export {
    auditPillarSchema,
    auditDepartmentSchema,
    auditTrailQuerySchema,
    auditTrailRowSchema,
    auditTrailResponseSchema,
    auditEmployeeSchema,
    auditEmployeesResponseSchema,
} from './audit';
export type {
    AnalyticsEventKind,
    AnalyticsClientEventKind,
    AnalyticsClientEvent,
    AnalyticsIngestRequest,
    AnalyticsIngestResponse,
} from './analytics';
export {
    ANALYTICS_EVENT_KINDS,
    analyticsEventKindSchema,
    analyticsClientEventKindSchema,
    analyticsClientEventSchema,
    analyticsIngestRequestSchema,
    analyticsIngestResponseSchema,
} from './analytics';
export type {
    WorkflowSummary,
    ListWorkflowsResponse,
    GetWorkflowResponse,
    SaveWorkflowRequest,
    SaveWorkflowResponse,
    DeleteWorkflowResponse,
    RunWorkflowResponse,
    GetScheduleResponse,
    SetScheduleRequest,
    SetScheduleResponse,
    ClearScheduleResponse,
} from './workflows';
export type {
    SecurityRefStatusDto,
    SecurityReferenceDto,
    ResolveSecurityReferenceRequest,
    ResolveSecurityReferenceResponse,
} from './security-reference';
export type {
    ClientReviewStatus,
    ClientReviewOrigin,
    ReviewStepKey,
    StepDisposition,
    AnchorFreshness,
    RegisterFilter,
    ReviewStepState,
    ClientReview,
    RegisterRow,
    RegisterResponse,
    ClientHeader,
    ClientReviewDetail,
    ClientReviewDigest,
    OpenReviewRequest,
    DispositionStepRequest,
    CompleteReviewRequest,
    CancelReviewRequest,
} from './client-review';
export type {
    ClientSort,
    ClientGrouping,
    ClientComplianceStatus,
    ClientBookRow,
    ClientBookStats,
    ListClientsResponse,
    HouseholdGroup,
    ListHouseholdsResponse,
    TriTierTerceroClient,
    TriTierSuitabilityRecord,
    TriTierPrimaryContact,
    TriTierClientRow,
    TriTierStats,
    ListTriTierResponse,
    ClientIdentity,
    ClientMandate,
    ClientPerformance,
    ClientFactFind,
    ClientReviewSummary,
    ClientHolding,
    ClientCash,
    ClientAccount as ClientBookAccount,
    ClientUmbrella,
    HouseholdMember,
    ClientHousehold,
    ClientKycAssessment,
    ClientVulnerabilitySummary,
    ClientKyc,
    ClientContactLink,
    ClientDetail,
    ClientExternalIdDto,
    ClientExternalIdsResponse,
    MatchCandidate,
    MatchCandidatesResponse,
    CreateClientRequest,
    UpdateClientRequest,
    RegisterAccountRequest,
    CreateHouseholdRequest,
    AddClientToHouseholdRequest,
    AddRelatedPersonRequest,
    ConfirmMatchRequest,
} from './client-book';
export type {
    ContactStatus,
    ContactKind,
    OrganisationType,
    ContactLifecycleAction,
    ContactRow,
    ContactsStats,
    ListContactsResponse,
    PersonContactDetail,
    OrganisationContactDetail,
    ContactDetail,
    ContactDuplicateCandidateDto,
    DuplicateCandidatesResponse,
    CreateContactRequest,
    UpdateContactRequest,
    SetContactStatusRequest,
    ReassignContactOwnerRequest,
    CreateOrganisationContactRequest,
    UpdateOrganisationContactRequest,
} from './contacts';
export {
    contactStatusSchema,
    contactKindSchema,
    organisationTypeSchema,
    contactLifecycleActionSchema,
    contactRowSearchFields,
} from './contacts';
export type {
    TerceroClientStatus,
    TerceroClientRow,
    TerceroClientsStats,
    ListTerceroClientsResponse,
} from './clients';
export { terceroClientStatusSchema } from './clients';
export type {
    SuitabilityRecordStatus,
    SuitabilityRecordAssessmentType,
    SuitabilityRecordEntityTypeValue,
    EntityIdentityConditionalField,
    SuitabilityRecordLifecycleAction,
    SuitabilityRecordApprovalAction,
    SuitabilityRecordRow,
    SuitabilityRecordPrimaryContact,
    SuitabilityRecordPartyType,
    SuitabilityRecordInvolvedParty,
    SuitabilityRecordLabelParts,
    SuitabilityRecordAnchorParts,
    SuitabilityRecordsStats,
    ListSuitabilityRecordsResponse,
    SuitabilityAssessmentContent,
    SuitabilityRecordDetail,
    CreateSuitabilityRecordRequest,
    UpdateSuitabilityRecordRequest,
    SetSuitabilityRecordStatusRequest,
    SetSuitabilityRecordApprovalRequest,
    ReassignSuitabilityRecordOwnerRequest,
    // SEP-178 — create the SUR's satellite artefacts in place.
    SuitabilityRecordClientCandidate,
    SuitabilityRecordClientCandidatesResponse,
    CreateSuitabilityRecordArtefactRequest,
} from './suitability-records';
export {
    suitabilityRecordStatusSchema,
    suitabilityRecordAssessmentTypeSchema,
    suitabilityRecordEntityTypeSchema,
    suitabilityRecordLifecycleActionSchema,
    suitabilityRecordApprovalActionSchema,
    suitabilityRecordPrimaryContactSchema,
    suitabilityRecordPartyTypeSchema,
    suitabilityRecordInvolvedPartySchema,
    suitabilityRecordRowSearchFields,
    suitabilityRecordMatchesSearch,
    suitabilityRecordAnchor,
    suitabilityRecordLabelParts,
    suitabilityRecordPickerLabel,
    SUITABILITY_RECORD_LABEL_SEPARATOR,
    SUITABILITY_RECORD_LABEL_MAX_REFS,
    // Entity identity (SEP-186) — the conditional-field rule, mirrored from
    // the ontology so the form renders exactly what the Action accepts.
    ENTITY_IDENTITY_CONDITIONAL_KEYS,
    ENTITY_IDENTITY_FIELD_LABELS,
    ENTITY_TYPE_CONDITIONAL_FIELDS,
    entityIdentityConditionalFields,
} from './suitability-records';
export type {
    RelationshipPartyType,
    RelationshipAppliesTo,
    RelationshipAgeBand,
    RelationshipRoleDto,
    ListRelationshipRolesResponse,
    RelationshipRow,
    ListRelationshipsResponse,
    RelationshipParty,
    BookRelationshipRow,
    BookRelationshipsStats,
    ListBookRelationshipsResponse,
    CreateRelationshipRequest,
    RelationshipMutationResponse,
    UpdateRelationshipRolesRequest,
    CreateRelationshipRoleRequest,
    UpdateRelationshipRoleRequest,
} from './relationships';
export {
    relationshipPartyTypeSchema,
    relationshipAppliesToSchema,
    relationshipAgeBandSchema,
    relationshipPairKind,
    relationshipPartySchema,
    bookRelationshipRowSchema,
    listBookRelationshipsResponseSchema,
    isSingleRoleRelationshipKind,
    RELATIONSHIP_PARTY_TYPE_LABELS,
} from './relationships';
export type {
    DeskDashboardStats,
    DeskDashboardClientRow,
    DeskDashboardResponse,
    DeskPerformanceRange,
    DeskBenchmarkRange,
} from './desk-dashboard';
export type {
    ComplyDashboardKpis,
    ComplyDashboardDeadline,
    ComplyAlertFeedItem,
    ComplyAttentionItem,
    ComplyDashboardResponse,
} from './comply-dashboard';
export type {
    ArtefactSummaryRow,
    CallArtefactRow,
    MonthlyNarrativeRow,
    ReviewQueuePendingResponse,
    FrontendReviewCounts,
    ReviewQueueCountsResponse,
    ContextField,
    ContextTranscriptLine,
    ContextBlock,
    ReviewContextResponse,
    ReviewContextQuery,
} from './review-queue';
export {
    contextFieldSchema,
    contextTranscriptLineSchema,
    contextBlockSchema,
    reviewContextResponseSchema,
    reviewContextQuerySchema,
} from './review-queue';
export type {
    RegulatoryReturnDto,
    RegulatoryReturnStatusDto,
    RegCalendarResponse,
} from './comply-reg-calendar';
export { regulatoryReturnStatusSchema } from './comply-reg-calendar';
export type {
    BreachCategoryDto,
    BreachSeverityDto,
    BreachRegisterStatusDto,
    BreachRegisterEntryDto,
    BreachRegisterResponse,
} from './comply-breach-register';
export {
    breachCategorySchema,
    breachSeveritySchema,
    breachRegisterStatusSchema,
} from './comply-breach-register';
export type {
    SuitabilityAlertDto,
    SuitabilityAlertTypeDto,
    SuitabilityAlertStatusDto,
    SuitabilityAlertSeverityDto,
    VigilFindingDto,
    SuitabilityResponse,
} from './comply-suitability';
export {
    suitabilityAlertTypeDtoSchema,
    suitabilityAlertStatusDtoSchema,
    suitabilityAlertSeverityDtoSchema,
} from './comply-suitability';
export type {
    ConsumerDutyResponse,
    ConsumerDutyAssessmentDto,
    ConsumerDutyClientScoreDto,
    VulnerableCustomerDto,
} from './comply-consumer-duty';
export type {
    FinCrimeKycResponse,
    EddOutcomeDto,
    KycReviewDto,
    EddCaseDto,
} from './comply-fin-crime-kyc';
export { eddOutcomeSchema } from './comply-fin-crime-kyc';
export type {
    TcTrackerResponse,
    TcRecordDto,
    CpdEntryDto,
    RecordCpdEntryBody,
} from './comply-tc-tracker';
export type {
    CmpReviewsResponse,
    CmpReviewItemDto,
    CmpFindingDto,
    AddCmpFindingBody,
} from './comply-cmp-reviews';
export type { FairValueResponse } from './comply-fair-value';
export type {
    CallIntelligenceResponse,
    CallExtractedFactDto,
    CallActionItemDto,
    CallKbNoteDto,
    CallIntelligenceDeskCallDto,
    CallIntelligenceClientDto,
} from './comply-call-intelligence';
export type {
    DeskClientKnowledgeResponse,
    DeskClientKB,
    DeskKBNote,
    DeskKBGraphNode,
    DeskKBGraphEdge,
    ClientConnectionDto,
    ClientConnectionRelationship,
    ClientKnowledgeDocumentDto,
    DeskCallsMeetingsResponse,
    DeskCallRow,
    DeskCallFactRow,
    DeskCallActionRow,
    DeskCallNoteRow,
    CallCitationSource,
    CallCitationSourcesResponse,
    OpsAuditLogEntryDto,
    OpsAuditLogResponse,
    HoldingNoteRow,
    MandateCatalogueEntryDto,
    MandateCatalogueResponse,
    DeskPortfolioHoldingDto,
    DeskPortfolioHoldingsResponse,
    DeskPortfolioHolderAccount,
    DeskPortfolioHolder,
    DeskPortfolioHoldingHoldersResponse,
    FeedItemDto,
    FeedItemActionOk,
} from './desk-pages';
export type {
    SuitabilityAssessmentFields,
    SuitabilityAssessmentDto,
    SuitabilityAssessmentGetResponse,
    SuitabilityPrefillSuggestion,
    SuitabilityPrefillReviewStatus,
} from './suitability-assessment';
export {
    suitabilityAssessmentFieldsSchema,
    suitabilityAssessmentDtoSchema,
    suitabilityAssessmentGetResponseSchema,
    suitabilityPrefillSuggestionSchema,
    suitabilityPrefillReviewStatusSchema,
    suitabilityPrefillListResponseSchema,
    suitabilityPrefillActionResponseSchema,
} from './suitability-assessment';
export type {
    VulnerabilityAnswersDto,
    VulnerabilityAssessmentDto,
    VulnerabilityAssessmentGetResponse,
    VulnerabilityOversightSummary,
    ContactVulnerabilitySummary,
    ListContactVulnerabilityAssessmentsResponse,
} from './vulnerability-assessment';
export {
    vulnerabilityAnswersSchema,
    vulnerabilityAnswersInstrumentSchema,
    vulnerabilityAssessmentDerivedSchema,
    vulnerabilityAssessmentDtoSchema,
    vulnerabilityAssessmentGetResponseSchema,
    vulnerabilityBandCountsSchema,
    vulnerabilityDriverCountsSchema,
    vulnerabilityOversightSummarySchema,
    contactVulnerabilitySummarySchema,
    listContactVulnerabilityAssessmentsResponseSchema,
} from './vulnerability-assessment';
export type {
    AmlAnswersDto,
    AmlAssessmentDto,
    ContactAmlSummary,
    ListContactAmlAssessmentsResponse,
} from './aml-assessment';
export {
    amlAnswersSchema,
    amlAssessmentDerivedSchema,
    amlAssessmentDtoSchema,
    contactAmlSummarySchema,
    listContactAmlAssessmentsResponseSchema,
} from './aml-assessment';
// Entity AML (SEP-186) — the EAML-#### SUR-level instrument for entity clients.
export type {
    EntityAmlAnswersDto,
    EntityAmlAssessmentDto,
    EntityAmlSummary,
    ListEntityAmlAssessmentsResponse,
} from './entity-aml-assessment';
export {
    entityAmlAnswersSchema,
    entityAmlAssessmentDtoSchema,
    entityAmlSummarySchema,
    listEntityAmlAssessmentsResponseSchema,
} from './entity-aml-assessment';
export type {
    MandateLetterInputs,
    MandateLetterContext,
    MandateLetterDto,
    MandateLetterGetResponse,
} from './mandate-letter';
export {
    mandateLetterInputsSchema,
    mandateLetterContextSchema,
    mandateLetterDtoSchema,
    mandateLetterGetResponseSchema,
} from './mandate-letter';
export type {
    ReviewableKind,
    ComposerAgent,
    StaffActionOk,
    StaffActionError,
    StaffActionResult,
    AgentTaskListQuery,
    ScheduledRun,
    ListScheduledRunsResponse,
    ReviewDecisionVerb,
    ReviewDecision,
    ReviewDecisionResult,
    ReviewDecisionsResponse,
} from './agent';
export {
    reviewableKindSchema,
    composerAgentSchema,
    staffActionOkSchema,
    staffActionErrorSchema,
    agentTaskListQuerySchema,
    scheduledRunSchema,
    listScheduledRunsResponseSchema,
    reviewDecisionVerbSchema,
    reviewDecisionSchema,
    reviewDecisionsRequestSchema,
    reviewDecisionsResponseSchema,
} from './agent';
export type {
    FirmOverviewResponse,
    FirmOverviewBreach,
    FirmOverviewKycReview,
    FirmOverviewComplianceAlert,
    ViewAggregatesResponse,
    // Operational Intelligence signal DTOs (View > Operational Intelligence).
    OperationalIntelligenceResponse,
    OpsReconSignal,
    OpsOverdrawnSignal,
    OpsTradeSignal,
    OpsLabelCount,
    // Custodian Analytics feed-coverage DTOs (View > Custodian Analytics).
    CustodianAnalyticsResponse,
    CustodianCoverageRow,
    // View performance DTOs (issue 352 Workstream A).
    FinancialPerformanceResponse,
    FinancialPerformanceGroup,
    InvestmentPerformanceResponse,
    AccountReturnsRow,
    CategoryReturn,
    BenchmarkingResponse,
    BenchmarkBandRow,
    BenchmarkAccountRow,
    FundManagementListResponse,
    TrustDetailResponse,
    RnsAnnouncementDto,
    ItpBreachDto,
    // Fund-management row DTOs (the per-trust screens read these directly).
    InvestmentTrustRow,
    ExposureSnapshotRow,
    DiscountSnapshotRow,
    GearingSnapshotRow,
    PolicyClauseRow,
    ShareholderRow,
    ContinuationVoteRow,
    BrokerCoverageRow,
    FundReportDraftRow,
} from './view-pages';
export type {
    AttritionBand,
    AttritionRow,
    AttritionBandCounts,
    AttritionKpiSummary,
    ClientIntelligenceResponse,
} from './view-client-intelligence';
export { attritionBandSchema } from './view-client-intelligence';
export type {
    DocumentTaxonomy,
    VaultRow,
    SharePointStatus,
    ExportPdfRequest,
    ExportPdfResponse,
} from './sharepoint';
export type {
    KycVendor,
    KycMatch,
    KycScreenStatus,
    KycScreenResult,
    KycApplicant,
    KycScreenIndividualRequest,
    KycScreenEntityRequest,
    KycApplicantRequest,
    KycWebhookPayload,
    KycStatusResponse,
    KycVendorStatus,
} from './kyc';
export type {
    CoacActionRow,
    CoacActionListResponse,
    CoacElectionStatus,
    CoacOpsStatus,
    CoacRoutingOutcome,
    CoacUrgencyRating,
    CoacRouteToImRequest,
    CoacRecordDecisionRequest,
    CoacApproveElectionRequest,
    CoacDefaultElectionRequest,
    // Exposure (command centre — discretionary / advisory / execution-only split)
    CoacServiceType,
    CoacExposureBucket,
    CoacExposureSummary,
    CoacExposureSummaryRequest,
    CoacExposureLine,
    CoacExposureBreakdown,
    // Per-account elections (WP-E)
    CoacAccountElectionRow,
    CoacAccountElectionView,
    CoacRecordAccountElectionRequest,
    CoacImResponse,
    CoacResponsesBreakdown,
    CoacResponsesRow,
    CoacResponsesSummaryRow,
    CoacCompleteActionRequest,
    CoacTitanEmail,
    // ADR-0016 action draft types
    CoacActionDraftRow,
} from './coac';
export type {
    OnboardingPipelineStage,
    OnboardingPipelineCaseStatus,
    OnboardingEnquirySource,
    KycResultStatus,
    PostMeetingNote,
    KycResult,
    SourceOfFundsDeclaration,
    OnboardingAuditEntry,
    OnboardingPipelineCase,
    OnboardingListResponse,
    OnboardingCaseResponse,
    CreateEnquiryRequest,
    AssignImRequest,
    TransitionRequest,
    PostMeetingNoteRequest,
    RemindRequest,
    ActorRequest,
    OnboardingCallKnowledgeResponse,
    OnboardingStageMetric,
    OnboardingAnalyticsResponse,
} from './onboarding';
export type {
    FactFindStatus,
    FactFindFreshness,
    FactFindClientType,
    CflBand,
    PrefillReviewStatus,
    VulnerabilityDriver,
    FactFindAnswer,
    FactFindResponse,
    AtrAssessment,
    CflWorkingStep,
    CflCalculation,
    FactFindVulnerabilityMarker,
    FactFindAnnotation,
    FactFindAuditEntry,
    FactFindVersion,
    FactFind,
    FactFindRegisterRow,
    FactFindRiskSummaryRow,
    FactFindRiskSummaryResponse,
    PrefillSuggestion,
    FactFindRegisterResponse,
    CreateDraftRequest,
    FactFindClientOption,
    FactFindClientsResponse,
    CreateFactFindRequest,
    CreateFactFindResponse,
    SaveSectionRequest,
    SaveAtrRequest,
    SaveCflRequest,
    FactFindTransitionRequest,
    AddAnnotationRequest,
    RefreshRequest,
    RefreshResponse,
    PrefillListResponse,
    PrefillActionResponse,
    FactFindSigningStatus,
    FactFindDocumentRecipient,
    FactFindDocument,
    FactFindDocumentResponse,
    FactFindSigningState,
    FactFindSigningStateResponse,
    SendForSignatureSigner,
    SendForSignatureRequest,
    MarkSignedRequest,
} from './fact-find';
export type { DocumentArea, DocumentStatus, DocumentDto } from './documents';
export { documentAreaSchema, documentStatusSchema, documentSchema } from './documents';
export type {
    PortalSessionStatus,
    PortalMessageRole,
    PortalDeliveryChannel,
    PortalDocumentCategory,
    PortalNotificationKind,
    PortalNotificationStatus,
    PortalCitation,
    ClientPortalSession,
    ClientPortalMessage,
    PortalLibraryDocument,
    ClientDocumentAccess,
    ClientPortalNotification,
    PortalHolding,
    PortalDashboard,
    PortalOverdrawnAccount,
    PortalActionItem,
    PortalDocumentRef,
    PortalPortfolio,
    PortalCashAccount,
    PortalCashByCurrency,
    PortalCash,
    PortalExposureBand,
    PortalConcentrationLine,
    PortalExposure,
    PortalHoldingDetail,
    PortalHoldingDetailResponse,
    PortalProfile,
    LoginRequest,
    LoginResponse,
    PortalCredential,
    PortalCredentialIssue,
    PortalCredentialRegenerate,
    EnsureCredentialRequest,
    RegenerateCredentialRequest,
    PortalSessionResponse,
    PostMessageRequest,
    PortalMessagesResponse,
    PortalDocumentsResponse,
    DocumentDownloadResponse,
    PortalNotificationsResponse,
    UpdateProfileRequest,
} from './portal';
export type {
    GovernanceMeetingKind,
    GovernanceRag,
    GovernanceStage,
    GovernanceItemStatus,
    GovernanceDecisionOutcome,
    GovernanceItemAuditEntry,
    GovernanceProgrammeItem,
    GovernanceDecision,
    GovernanceMeeting,
    GovernanceAgendaLine,
    GovernancePaper,
    StaleAmberFlag,
    GovernanceDriftResponse,
    GovernanceItemsResponse,
    GovernanceItemResponse,
    GovernanceMeetingsResponse,
    GovernanceMeetingDetailResponse,
    GovernancePapersResponse,
    StatusUpdateRequest,
} from './governance';
export type {
    VulnerabilitySeverity,
    VulnerabilityFlagDto,
    VulnerabilityEvidenceDto,
    VulnerabilityAdaptationPlanDto,
    VulnerabilityRecordDto,
    VulnerabilityDriverPrevalence,
    VulnerabilityDashboard,
    VulnerabilityCaseStudy,
    ConfirmFlagRequest,
    CreateFlagRequest,
    ConsentUpdateRequest,
} from './vulnerability';
export type {
    HouseModelAllocation,
    HouseModel,
    SecurityListEntry,
    PcfDeviationDetail,
    ImDeviationCell,
    PcfDashboard,
    BuyListImpactLine,
    BuyListChange,
    JustifyDeviationRequest,
    BuyListChangeRequest,
} from './pcf';
export type {
    ReconciliationBreakStatus,
    ReconciliationBreakDto,
    ReconciliationKind,
    ResolveBreakRequest,
    AssignBreakRequest,
    AutoResolveBreaksRequest,
    AutoResolveBreaksResponse,
    BreakResponse as ReconciliationBreakResponse,
    ListBreaksResponse,
    ReconciliationResultDto,
    MasonClassificationDto,
    ListResultsResponse,
} from './reconciliation';
export type { SnapshotDebugResponse } from './snapshot';
export type {
    OdCashRowDto,
    OverdrawnCashResponse,
    UploadOverdrawnCashResponse,
    AssignOverdraftOwnerRequest,
    ResolveOverdraftRowRequest,
    EscalateOverdraftRowRequest,
    OverdraftActionResponse,
} from './cash';
export type { OpsTradeDto, OpsTradeStatus, ListTradesResponse } from './ops';
export { opsTradeDtoSchema, opsTradeStatusSchema, listTradesResponseSchema } from './ops';
export type { OutstandingFeeDto, FeeScheduleDto } from './ops';
export type {
    CashPositionRowDto,
    CashPositionAlertDto,
    CashPositionsResponse,
    UploadCashAccountsResponse,
} from './cash';
export type {
    ManagerAliasSource,
    ManagerAliasRow,
    ListManagerAliasesResponse,
    CreateManagerAliasRequest,
    CreateManagerAliasResponse,
    ReattributionSummary,
    ReattributionUnresolved,
} from './manager-alias';
export type {
    BookHealthResponse,
    BookHealthDeskUser,
    BookHealthUnresolvedManager,
    BookHealthStaleAttribution,
} from '../schemas/book-health';
export type {
    McpConnectionStatus,
    McpConnectionDto,
    McpClientDto,
    McpConnectionsResponse,
    McpClientsResponse,
    McpRevokeAccessRequest,
    McpRemoveClientRequest,
    McpAdminMutationResponse,
} from '../schemas/mcp-admin';
export {
    mcpConnectionStatusSchema,
    mcpConnectionDtoSchema,
    mcpClientDtoSchema,
    mcpConnectionsResponseSchema,
    mcpClientsResponseSchema,
    mcpRevokeAccessRequestSchema,
    mcpRemoveClientRequestSchema,
    mcpAdminMutationResponseSchema,
} from '../schemas/mcp-admin';
export type {
    FirmConfigDto,
    FirmConfigPatchDto,
    TolerancesDto,
    TolerancesPatchDto,
    NotificationsPatchDto,
    AddUserRequest,
    UpdateUserRequest,
} from './firm-config';
export {
    firmConfigSchema,
    firmConfigPatchSchema,
    tolerancesSchema,
    tolerancesPatchSchema,
    notificationsPatchSchema,
    addUserRequestSchema,
} from './firm-config';
export type { SystemStatusComponentDto, SystemStatusResponse } from './system-status';
export { systemStatusComponentSchema, systemStatusResponseSchema } from './system-status';
export type {
    RetentionCategoryDto,
    RetentionScheduleEntryDto,
    LegalHoldDto,
    RetentionCategoryReportDto,
    RetentionSweepReportDto,
    RetentionOverviewDto,
    SetRetentionCategoryDto,
    CreateLegalHoldDto,
    ReleaseLegalHoldDto,
} from './retention';
export {
    retentionContract,
    retentionCategorySchema,
    retentionScheduleEntrySchema,
    legalHoldSchema,
    retentionCategoryReportSchema,
    retentionSweepReportSchema,
    retentionOverviewSchema,
    setRetentionCategorySchema,
    createLegalHoldSchema,
    releaseLegalHoldSchema,
} from './retention';
export type {
    KpiAggregateDto,
    KpiManagerAggregateDto,
    KpiPerCategoryDto,
    KpiPerManagerDto,
    KpiTrendPointDto,
    KpiFirmTotalsDto,
    KpiAumAuaDto,
    KpiFirmResponse,
    KpiMyResponse,
    ReportingCategory,
} from './kpi';
export {
    REPORTING_CATEGORIES,
    kpiAggregateSchema,
    kpiManagerAggregateSchema,
    kpiTrendPointSchema,
    kpiFirmResponseSchema,
    kpiMyResponseSchema,
} from './kpi';
export type {
    ReportCategory,
    ReportFrequency,
    ReportFormat,
    ReportDefinitionDto,
    ReportCatalogueResponse,
} from './reporting';
export {
    reportCategorySchema,
    reportFrequencySchema,
    reportFormatSchema,
    reportDefinitionSchema,
    reportCatalogueResponseSchema,
} from './reporting';
export type {
    SeverityFilter,
    NotificationPrefsDto,
    NotificationPrefsPatchDto,
    Theme,
    Density,
    DisplayPrefsDto,
    DisplayPrefsPatchDto,
} from './user-prefs';
export {
    severityFilterSchema,
    notificationPrefsSchema,
    notificationPrefsPatchSchema,
    themeSchema,
    densitySchema,
    displayPrefsSchema,
    displayPrefsPatchSchema,
} from './user-prefs';
export type { DocumentDraftDto } from './document-drafts';
export { documentDraftSchema } from './document-drafts';
